import { Component} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';


@Component({
  selector: 'app-sign-invalid-modal',
  templateUrl: './sign-invalid.component.html',
  styleUrls: ['./sign-invalid.component.scss'],
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule],
})

export class SignInvalidComponent{



  }
           

